import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";
import AOS from "aos";
import "aos/dist/aos.css";

const slides = [
  {
    image:
      "https://i.pinimg.com/736x/02/04/62/020462cbbd5e696ff61439d9ae533ec9.jpg",
    title: "Building Dreams Into Reality",
    subtitle:
      "Professional construction and real estate services with over 15 years of experience",
    cta1: { text: "Get Started", href: "/contact" },
    cta2: { text: "View Projects", href: "/projects" },
  },
  {
    image: "https://www.nirmanconstruction.net/images/banner2.jpg",
    title: "Modern Architecture & Design",
    subtitle:
      "Creating innovative spaces that blend functionality with aesthetic appeal",
    cta1: { text: "Get started", href: "/contact" },
    cta2: { text: "Learn More", href: "/about" },
  },
  {
    image:
      "https://i.pinimg.com/736x/21/1a/d8/211ad85f92e12fa8b909036291cf34f2.jpg",
    title: "Quality Construction Services",
    subtitle:
      "From renovation to new construction, we deliver excellence in every project",
    cta1: { text: "Contact Us", href: "/contact" },
    cta2: { text: "Real Estate", href: "/real-estate" },
  },
];

const HeroCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    // AOS.init({ duration: 1000, once: false });

    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section
      className="relative h-screen overflow-hidden"
      style={{ height: "calc(100vh - 96px)" }}
    >
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-transform duration-500 ease-in-out ${
            index === currentSlide
              ? "translate-x-0"
              : index < currentSlide
              ? "-translate-x-full"
              : "translate-x-full"
          }`}
        >
          <div className="relative h-full flex items-center justify-center bg-gradient-to-r from-blue-600 to-blue-800">
            {/* Background image */}
            <div
              className="absolute inset-0 bg-cover bg-center z-0"
              style={{ backgroundImage: `url('${slide.image}')` }}
            ></div>

            {/* Dark overlay on top of image */}
            <div className="absolute inset-0 bg-black opacity-50 z-10"></div>

            {/* Slide Content */}
            <div className="relative z-20 text-center text-white max-w-4xl mx-auto px-4">
              <h1
                className="text-4xl md:text-6xl font-bold mb-6"
                data-aos="fade-up"
                data-aos-delay="200"
                style={{ color: "orange" }}
              >
                {slide.title}
              </h1>
              <p
                className="text-lg md:text-2xl mb-8"
                data-aos="fade-up"
                data-aos-delay="400"
                // style={{ color: "yellow" }}
              >
                {slide.subtitle}
              </p>
              <div
                className="space-x-4"
                data-aos="fade-up"
                data-aos-delay="600"
              >
                {/* <Link to={slide.cta1.href}>
                  <button className="bg-white text-blue-800 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition duration-300">
                    {slide.cta1.text}
                  </button>
                </Link>
                <Link to={slide.cta2.href}>
                  <button className="border border-white text-white px-6 py-3 rounded-lg hover:bg-white hover:text-blue-800 transition duration-300">
                    {slide.cta2.text}
                  </button>
                </Link> */}
                {/* <Link to={slide.cta2.href}>
                  <button className="border border-white text-white px-6 py-3 rounded-lg hover:bg-white hover:text-blue-800 transition duration-300">
                    {slide.cta2.text}
                  </button>
                </Link> */}
                {/* <Link to={slide.cta1.href}>
                  <button className="bg-[#6FEF34] text-blue-700 px-6 py-3 rounded-lg font-semibold hover:text-white transition duration-300">
                    {slide.cta1.text}
                  </button>
                </Link> */}
                {/* <Link to={slide.cta1.href}>
                  <button className="bg-white text-blue-700 px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 hover:text-white transition duration-300">
                    {slide.cta1.text}
                  </button>
                </Link>

                <Link to={slide.cta2.href}>
                  <button className="bg-blue-700 border border-blue-700 text-white px-6 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-700 transition duration-300">
                    {slide.cta2.text}
                  </button>
                </Link> */}
                {/* text-[#80DEEA] */}
                <Link to={slide.cta1.href}>
                  <button className="bg-blue-700 text-[#80DEEA] px-6 py-3 rounded-lg font-semibold hover:bg-[#283593] hover:text-[#B2EBF2] transition duration-300">
                    {slide.cta1.text}
                  </button>
                </Link>
                <Link to={slide.cta2.href}>
                  <button className="border border-white text-white px-6 py-3 rounded-lg hover:bg-white hover:text-blue-700 transition duration-300">
                    {slide.cta2.text}
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Navigation Arrows */}
      {/* <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 transform -translate-y-1/2 z-20 bg-white/20 hover:bg-white/30 rounded-full p-2 transition-colors"
      >
        <ChevronLeft className="h-6 w-6 text-white" />
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 transform -translate-y-1/2 z-20 bg-white/20 hover:bg-white/30 rounded-full p-2 transition-colors"
      >
        <ChevronRight className="h-6 w-6 text-white" />
      </button> */}

      {/* Dots Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 flex space-x-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-colors ${
              index === currentSlide ? "bg-white" : "bg-white/50"
            }`}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroCarousel;
